import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { FlowDefinition } from '../../types/flow';

interface FlowState {
  flows: FlowDefinition[];
  activeFlowId: string | null;
  loading: boolean;
  error: string | null;
}

const initialState: FlowState = {
  flows: [],
  activeFlowId: null,
  loading: false,
  error: null,
};

const flowSlice = createSlice({
  name: 'flow',
  initialState,
  reducers: {
    setFlows(state, action: PayloadAction<FlowDefinition[]>) {
      state.flows = action.payload;
    },
    setActiveFlow(state, action: PayloadAction<string | null>) {
      state.activeFlowId = action.payload;
    },
    updateFlow(state, action: PayloadAction<FlowDefinition>) {
      const idx = state.flows.findIndex(f => f.id === action.payload.id);
      if (idx >= 0) {
        state.flows[idx] = action.payload;
      } else {
        state.flows.push(action.payload);
      }
    },
    addFlow(state, action: PayloadAction<FlowDefinition>) {
      state.flows.push(action.payload);
    },
    removeFlow(state, action: PayloadAction<string>) {
      state.flows = state.flows.filter(f => f.id !== action.payload);
    },
    toggleFlowEnabled(state, action: PayloadAction<{ id: string; enabled: boolean }>) {
      const flow = state.flows.find(f => f.id === action.payload.id);
      if (flow) {
        flow.enabled = action.payload.enabled;
      }
    },
    setFlowLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setFlowError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const {
  setFlows,
  setActiveFlow,
  updateFlow,
  addFlow,
  removeFlow,
  toggleFlowEnabled,
  setFlowLoading,
  setFlowError,
} = flowSlice.actions;

export default flowSlice.reducer;